import { render, staticRenderFns } from "./StagingModal.vue?vue&type=template&id=e8ddca38&scoped=true&"
import script from "./StagingModal.vue?vue&type=script&lang=js&"
export * from "./StagingModal.vue?vue&type=script&lang=js&"
import style0 from "./StagingModal.vue?vue&type=style&index=0&id=e8ddca38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ddca38",
  null
  
)

export default component.exports